import { axiosNode } from '../config/axiosConfig';
import { alertErrorResponse } from '../utils/alertResponseHttpUtil';
import { alertSuccess } from '../utils/alertUtil';

const RUTA_EMPRESAS = 'empresas';

export default {
  async crear(body) {
    try {
      const response = await axiosNode.post(RUTA_EMPRESAS, body);
      alertSuccess('Empresa creada correctamente');
      return response.data;
    } catch (error) {
      alertErrorResponse(error.response.data);
    }
  },

  async buscarTodos(filtros) {
    try {
      const params = getParamsBuscarTodos(filtros);
      const response = await axiosNode.get(RUTA_EMPRESAS, { params });
      return response.data;
    } catch (error) {
      alertErrorResponse(error.response.data);
    }
  },

  async buscarSucursales(nit) {
    try {
      const response = await axiosNode.get(
        `${RUTA_EMPRESAS}/nit/${nit}/sucursales`
      );
      return response.data;
    } catch (error) {
      alertErrorResponse(error.response.data);
    }
  },

  async actualizarPorNit(nit, datos) {
    try {
      const response = await axiosNode.put(
        `${RUTA_EMPRESAS}/nit/${nit}`,
        datos
      );
      alertSuccess('Empresa actualizada correctamente');
      return response.data;
    } catch (error) {
      alertErrorResponse(error.response.data);
    }
  },

  async eliminarPorNit(nit) {
    try {
      await axiosNode.delete(`${RUTA_EMPRESAS}/nit/${nit}`);
      alertSuccess('Empresa eliminada correctamente');
    } catch (error) {
      alertErrorResponse(error.response.data);
    }
  },
};

const getParamsBuscarTodos = (filtros = null) => {
  if (!filtros) {
    return {};
  }
  const { nit, tieneConvenio, estaActivo, page, limit } = filtros;
  const params = {};
  if (nit) {
    params.nit = nit;
  }
  if (tieneConvenio !== null) {
    params.tiene_convenio = tieneConvenio;
  }
  if (estaActivo !== null) {
    params.esta_activo = estaActivo;
  }
  if (page) {
    params.page = page;
  }
  if (limit) {
    params.limit = limit;
  }
  return params;
};
